module.exports = __webpack_public_path__ + "static/media/lenuta_alboaie.d6096785.png";